import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', (state) => { // top-level app state has been reset
    // TODO: delete this when slideware is migrated to redux.
    // this is only used in the legacy activity explorer
    dispatcher.listenTo(state.appStates.activities, 'change:bulkAction', (model, bulkAction) => {
      if (bulkAction === 'insert') {
        const activity = state.appStates.activities.get('selected')
        state.appStates.slideware.set({ page: 'insert', activity })
        store.dispatch(appSlice.pageUpdated('slideware'))
        state.appStates.activities.finishBulkAction()
      }
    })
  })
}
